import { Spin } from 'antd';
import styles from './PageLoading.module.scss';

export const PageLoading = () => {
  return (
    <div className={styles.pageLoading}>
      <Spin size="large" tip="加载中..." spinning>
        <div style={{ minHeight: 200 }} />
      </Spin>
    </div>
  );
};
